import occupant from './occupant';
import moveInInformation from './moveInInformation';
import pet from './pet';
import vehicle from './vehicle';
import emergencyContact from './emergencyContact';
import currentResidency from './currentResidency';
import employmentInformation from './employmentInformation';
import uploadedDoc from './uploadedDoc';
import stateManager from '../state';

const ARRAYS_TO_VALIDATE = {
  occupants: occupant,
  pets: pet,
  vehicles: vehicle,
  emergencyContacts: emergencyContact,
  employmentInformations: employmentInformation
};

const OBJECTS_TO_VALIDATE = { moveInInformation, currentResidency, uploadedDoc };

const isAnActualObject = (value) => typeof value === 'object' && !(value instanceof Date) && value !== null;

const validateItem = (item, validators, selectedLanguage) => {
  const validated = { ...item, hasError: false };
  Object.keys(item).forEach((itemField) => {

    // address field is a string for edit application
    // but same field is an object for other scenerio
    const validator = validators[itemField];
    if (itemField === 'address' && !isAnActualObject(itemField)) {
      validators['address'] = validators['plainAddress'];
    }

    if (!validator) return;
    const value = item[itemField];
    if (isAnActualObject(value)) {
      validated[itemField] = validateItem(value, validator, selectedLanguage);
      return;
    }
    if (typeof validator.isValid !== 'function') return;
    const errorField = `${itemField}Error`;
    const isValid = validator.isValid(value, item);
    if (!isValid) {
      const errorMsg = validator.message(selectedLanguage, item);
      validated.hasError = true;
      validated[errorField] = errorMsg;
    } else {
      validated[errorField] = '';
    }
  });
  return validated;
};

const validateList = (list, validators, selectedLanguage) => list.map((item) => validateItem(item, validators, selectedLanguage));

const tabs = [
  'landingPage',
  'occupants',
  'moveInInformation',
  'pets',
  'vehicles',
  'currentResidency',
  'employmentInformations',
  'emergencyContacts',
  'uploadedDoc',
  'review'
];

export default (validateAll) => {
  const state = stateManager.store.getState();
  const index = tabs.indexOf(state.selectedTabId);

  const toValidate = validateAll ? tabs : tabs.slice(0, index);
  const newState = { ...state };
  Object.keys(ARRAYS_TO_VALIDATE).filter((k) => toValidate.includes(k)).forEach((field) => {
    newState[field] = validateList(state[field], ARRAYS_TO_VALIDATE[field], state.selectedLanguage);
  });

  Object.keys(OBJECTS_TO_VALIDATE).filter((k) => toValidate.includes(k)).forEach((field) => {
    newState[field] = validateItem(state[field], OBJECTS_TO_VALIDATE[field], state.selectedLanguage);
  });
  stateManager.set(newState);
};
